import { datadogRum } from '@datadog/browser-rum';
import type { ApplicationLogContext, Logger } from '../logger/logger';

const loadDatadogRUM = ({
  environment,
  enabled,
  buildVersion,
}: LoggerConfig) => {
  datadogRum.init({
    applicationId: '9774b829-5d1a-4add-bc2e-2f14d364e6bf',
    clientToken: 'pubab01373fad0827f4e4081d10b0406df7',
    site: 'datadoghq.com',
    service: 'hirer-ad-price-lookup',
    version: buildVersion,
    env: environment,
    sessionReplaySampleRate: enabled ? 100 : 0,
    trackUserInteractions: true,
    allowedTracingUrls: [
      'https://talent.seek.com.au',
      'https://talent.seek.co.nz',
      'https://talent.staging.seek.com.au',
      'https://talent.staging.seek.co.nz',
      /http:\/\/hirer-graphql-api-.*\.hirer\.dev\.outfra\.xyz/,
    ],
  });
};

interface LoggerConfig {
  environment: string;
  buildVersion?: string;
  enabled?: boolean;
}

const configureDatadogGlobalTags = (
  context: Partial<ApplicationLogContext>,
) => {
  const tags = {
    ...datadogRum.getGlobalContext(),
    ...context,
  };
  datadogRum.setGlobalContext(tags);
};

const createDatadogLogger = ({
  environment,
  buildVersion,
  enabled = true,
}: LoggerConfig): Logger => {
  loadDatadogRUM({ environment, enabled, buildVersion });

  return Object.freeze({
    error: (message: string, context: any) => {
      const error = context?.error ?? new Error(message);
      datadogRum.addError(error, {
        ...context,
        message,
      });
    },
    configureApplicationContext: configureDatadogGlobalTags,
  });
};

export { createDatadogLogger };
